import React from 'react';
import { Search, Settings, User, Menu, Info } from 'lucide-react';
import './Header.css';
import Logo from './Logo';

interface HeaderProps {
  title?: string;
  onMenuClick?: () => void;
  onLogout?: () => void;
  onOpenSettings?: () => void;
  bio: string;
  setBio: (bio: string) => void;
  isMobile?: boolean;
  selectedLanguage?: string;
  onLanguageSelect?: (language: string) => void;
  onOpenInfo?: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, onMenuClick, onLogout, onOpenSettings, bio, setBio, isMobile = false, selectedLanguage, onLanguageSelect, onOpenInfo }) => {
  const [showProfile, setShowProfile] = React.useState(false);
  const username = typeof window !== 'undefined' ? localStorage.getItem('codenest_user') : 'Developer';
  const [langOpen, setLangOpen] = React.useState(false);

  const mobileLanguages = [
    { id: 'javascript', name: 'JavaScript' },
    { id: 'python', name: 'Python' },
    { id: 'typescript', name: 'TypeScript' },
    { id: 'java', name: 'Java' },
    { id: 'cpp', name: 'C++' },
  ];

  const idToName = (id?: string) => {
    if (!id) return 'Lang';
    const found = mobileLanguages.find(l => l.id === id);
    return found ? found.name : id.charAt(0).toUpperCase() + id.slice(1);
  };

  return (
    <header className="header animate-fade-in">
      <div className="header-left">
        <button className="mobile-menu-btn" onClick={onMenuClick}>
          <Menu size={18} />
        </button>
        {isMobile && (
          <div className="mobile-lang">
            <button className="mobile-lang-btn" onClick={() => setLangOpen(!langOpen)}>
              {idToName(selectedLanguage)}
            </button>
            {langOpen && (
              <div className="mobile-lang-dropdown">
                {mobileLanguages.map(l => (
                  <button key={l.id} className={`mobile-lang-item ${selectedLanguage === l.id ? 'active' : ''}`} onClick={() => { onLanguageSelect?.(l.id); setLangOpen(false); }}>
                    {l.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
        <div className="logo">
          <Logo size={28} />
          <span className="logo-text" style={{ marginLeft: 10 }}>Codenest</span>
          <span className="logo-subtitle">AI</span>
        </div>
      </div>

      <div className="header-right">
        <button className="header-btn" onClick={onOpenSettings} title="Settings">
          <Settings size={18} />
        </button>
        <div className="user-profile-container">
          <button
            className="user-profile-btn"
            onClick={() => setShowProfile(!showProfile)}
            title="Profile & Settings"
          >
            <User size={18} />
            <span className="username-text">{username}</span>
          </button>

          {showProfile && (
            <div className="profile-dropdown">
              <div className="profile-info">
                <div className="profile-name">{username}</div>
                <input
                  className="bio-input"
                  value={bio}
                  onChange={(e) => setBio(e.target.value)}
                  placeholder="Your bio..."
                  title="Click to edit bio"
                />
              </div>
              <div className="profile-divider"></div>
              <button className="logout-btn" onClick={onLogout}>
                Log Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;